/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import useApi from "../../services/api";
import { handleApiErrors } from "../../utils/handleErrors";
import { useMemo } from "react";

function Membership({ user }) {
  const { loyal_member_expiration, loyal_member_points: lmp } = user;
  const loyalMemberActive = useMemo(() => {
    return new Date() < new Date(loyal_member_expiration);
  }, []);

  const { push } = useHistory();

  const [loyalsInfo, setLoyalsInfo] = useState({});

  const { ApiGetLoyalMember } = useApi();

  async function handleLoyalMember() {
    const { data } = await ApiGetLoyalMember();
    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    data.sort((a, b) => {
      if (a.target_points < b.target_points) return -1;
      if (a.target_points > b.target_points) return 1;
      return 0;
    });

    for (let i = 0; i < data.length; i++) {
      if (lmp >= data[i].target_points && (data[i + 1] ? lmp < data[i + 1].target_points : true)) {
        setLoyalsInfo({ current: data[i], next: data[i + 1] });
      }
    }
  }

  useEffect(() => {
    handleLoyalMember();
  }, [lmp]);

  return (
    <div className="membership-colwarp">
      <div className="membership-col">
        <div
          className={`loyal-member text-uppercase 
            ${loyalsInfo?.current?.name === "Silver" && "sliver-member-warp"}
            ${loyalsInfo?.current?.name === "Gold" && "gold-member-warp"}
            ${loyalsInfo?.current?.name === "Platinum" && "platinum-member-warp"}
            ${loyalsInfo?.current?.name === "Diamond" && "diamond-member-warp"}
        
        `}
        >
          <span className="icon">
            <img src="/images/crown-ico-white.png" alt="" />
          </span>
          {t("General.LoyalMember")}
          {loyalMemberActive ? (
            <span
              className={`member-type 
            ${loyalsInfo?.current?.name === "Silver" && "sliver-member"}
            ${loyalsInfo?.current?.name === "Gold" && "gold-member"}
            ${loyalsInfo?.current?.name === "Platinum" && "platinum-member"}
            ${loyalsInfo?.current?.name === "Diamond" && "diamond-member"}
            `}
            >
              {loyalsInfo?.current?.name}
            </span>
          ) : (
            <span className="member-disabled">
              {t("General.Disabled")} <i className="fas fa-times-circle"></i>
            </span>
          )}
        </div>
      </div>
      <div className="membership-col">
        {loyalMemberActive ? (
          <div className="member-progress sliver-progress">
            {loyalsInfo?.current?.name !== "Diamond" && (
              <>
                <h5
                  className="text-uppercase"
                  dangerouslySetInnerHTML={{
                    __html: t("General.MembershipCountdown", {
                      color:
                        (loyalsInfo?.current?.name === "Silver" && "color-gold") ||
                        (loyalsInfo?.current?.name === "Gold" && "color-lblue") ||
                        (loyalsInfo?.current?.name === "Platinum" && "color-lmengata"),
                      points: loyalsInfo?.next?.target_points - lmp,
                      nextLevel: loyalsInfo?.next?.name,
                    }),
                  }}
                />

                <div className="member-progress-inner">
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${((lmp * 100) / loyalsInfo?.next?.target_points).toFixed(0)}%` }}
                      aria-valuenow={((lmp * 100) / loyalsInfo?.next?.target_points).toFixed(0)}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  {loyalsInfo?.next?.name === "Gold" && <img src="/images/star-shap.png" alt="" />}
                  {loyalsInfo?.next?.name === "Platinum" && <img src="/images/platinum-ico.png" alt="" />}
                  {loyalsInfo?.next?.name === "Diamond" && <img src="/images/diamond.png" alt="" />}
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="loyal-active-btn">
            <button
              type="button"
              className="activeloyal-btn text-uppercase"
              onClick={() => push(DefRoutes.RechargeLoyalMember)}
            >
              {t("General.ActiveLoyalMember")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Membership;
